<template>
  <div>
    <apexchart
      v-if="hasDates && dayCategories.length"
      type="bar"
      height="460"
      :options="daysOpts"
      :series="daysSeries"
    />
    <div
      v-else
      class="d-flex flex-column justify-center align-center grey--text"
      style="min-height: 400px"
    >
      <v-icon size="48" color="grey lighten-2">mdi-calendar-range</v-icon>
      <span class="text-body-2 mt-3">{{ $t("no_data") }}</span>
      <span class="text-caption grey--text text--lighten-1 mt-1">
        Select a wider date range to see the daily trend
      </span>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const SHIFT_COLORS = ["#1E88E5", "#43A047", "#FB8C00", "#8E24AA"];

export default {
  name: "GroupMealsDaysChart",
  components: { apexchart: VueApexCharts },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    hasDates() {
      return this.orders.some((item) => !!item.date);
    },
    dayAgg() {
      const map = {};
      for (const item of this.orders) {
        if (!item.date) continue;
        if (!map[item.date]) map[item.date] = [0, 0, 0, 0];
        if (item.shift_1 !== undefined) {
          map[item.date][0] += Number(item.shift_1 || 0);
          map[item.date][1] += Number(item.shift_2 || 0);
          map[item.date][2] += Number(item.shift_3 || 0);
          map[item.date][3] += Number(item.shift_4 || 0);
        } else {
          const s = (item.shift || 1) - 1;
          if (s >= 0 && s < 4) map[item.date][s] += Number(item.quantity || 0);
        }
      }
      return map;
    },
    dayCategories() {
      return Object.keys(this.dayAgg).sort();
    },
    daysSeries() {
      return this.shiftLabels.map((label, i) => ({
        name: label,
        data: this.dayCategories.map((d) => this.dayAgg[d]?.[i] || 0),
      }));
    },
    daysOpts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: { show: true },
          zoom: { enabled: true },
          fontFamily: "Roboto, sans-serif",
        },
        plotOptions: { bar: { horizontal: false, borderRadius: 3, columnWidth: "60%" } },
        colors: SHIFT_COLORS,
        xaxis: {
          categories: this.dayCategories,
          labels: { style: { fontSize: "11px" } },
        },
        legend: { position: "bottom" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: "#f1f1f1" },
      };
    },
  },
};
</script>
